/**
 * Centralized authentication manager
 * Provides a clean bridge between React contexts and axios
 */

class AuthManager {
  private headers: Record<string, string> = {};

  setHeaders(headers: Record<string, string | null | undefined>): void {
    Object.entries(headers).forEach(([key, value]) => {
      if (value === null || value === undefined) {
        delete this.headers[key];
      } else {
        this.headers[key] = value;
      }
    });
  }

  getAuthHeaders(): Record<string, string> {
    return { ...this.headers };
  }
}

export const authManager = new AuthManager();
